<template>
  <ActionMenu :menu-options="menuOptions" icon-type="kebab" />
</template>

<script lang="ts">
import ActionMenu from '@/components/action_menu/ActionMenu.vue';
import { MenuItemOptions } from '@/components/action_menu/__types__/ActionMenuTypes';
import StarOutlineIcon from '@/graphics/icons/StarOutlineIcon.vue';
import WarningOutlineIcon from '@/graphics/icons/WarningOutlineIcon.vue';
import { getSupportTicketHref, buildReportMenuItem } from '@/apps/messages/helpers/channelHeaderActionsReport';

export default {
  name: 'ChannelHeaderActionsProvider',
  components: {
    ActionMenu,
  },
  props: {
    correspondingUserAccountId: {
      type: String,
      default: '',
    },
    currentChannelUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    menuOptions(): MenuItemOptions[] {
      const options: MenuItemOptions[] = [];

      if (this.correspondingUserAccountId) {
        options.push({
          icon: StarOutlineIcon,
          height: 24,
          width: 24,
          labelText: 'Request a review',
          to: { path: '/provider/reviews/request' },
          click: () => {},
        });
      }

      options.push(buildReportMenuItem(getSupportTicketHref(this.currentChannelUrl), WarningOutlineIcon, 24, 24));

      return options;
    },
  },
};
</script>
